import { LIST_TYPE } from "@/shared/types/atoms.types";
import React from "react";
import ListSection from "../atoms/ListSection";

interface RepresentationsListProps {}

export const representationsList = [
  {
    index: "5.1.",
    description:
      "You have reviewed and understand these Affiliate Terms and agree to be bound by its terms.",
  },
  {
    index: "5.2.",
    description:
      "Your acceptance of these Affiliate Terms and participation in the Affiliate Program will not violate (i) any provision of law, rule, or regulation to which You are subject, (ii) any order, judgment, or decree applicable to you or binding upon Your assets or properties, (iii) any provision of Your by-laws or certificate of incorporation, or (iv) any agreement or other instrument applicable to you or binding upon Your assets or properties.",
  },
  {
    index: "5.3.",
    description:
      "During the Term, You will not include in Your promotional content that is, unlawful, harmful, threatening, defamatory, obscene, harassing, racially, ethically, or otherwise objectionable or in violation of these Affiliate Terms and/or the Platform Terms.",
  },
  {
    index: "5.4.",
    description: "You are at least eighteen (18) years of age.",
  },
  {
    index: "5.5.",
    description:
      "Each Qualified Referral is valid, genuine, and unique and meets the criteria Referral Rewards as provided in these Affiliate Terms.",
  },
];

const RepresentationsList: React.FC<RepresentationsListProps> = () => {
  return (
    <div>
      {representationsList.map((data) => (
        <React.Fragment key={data.index}>
          <ListSection
            listIndex={data.index}
            description={data.description}
            listType={LIST_TYPE.LIST2}
          />
        </React.Fragment>
      ))}
    </div>
  );
};

RepresentationsList.displayName = "RepresentationsList";

export default RepresentationsList;
